import { State } from '.';

export const selectors = {
    getAccountIdentity: (
        state: State
    ): string => state.identityName,
    getAccountLocked: (
        state: State
    ): boolean => state.locked,
    getAccountName: (
        state: State
    ): string => state.name,
    getCoordinates: (
        state: State
    ): Undefinable<PatientCoordinates> => state.coordinates,
    getPatientId: (
        state: State
    ): number => state.impsId,
};
